module.exports = __webpack_public_path__ + "img/Futurebank.b7917f43.svg";